import React, { useState, useEffect, useCallback, useRef } from "react";
import $ from "jquery";
import { BottomScrollListener, useBottomScrollListener } from "react-bottom-scroll-listener";
import { debounce } from "lodash";
import {
  LOW_DEBOUNCE_TIME,
  buildEditableSelect,
  IPAD_WIDTH,
  enterDownHandler, parseCategoryName, parseLanguage, titleize, pluralize, DEFAULT_PER_PAGE_PARAM
} from "../../utils/utils";
import I18n from 'i18n.js.erb'
import AlertPopup from "./AlertPopup";
import IconTooltip from "./IconTooltip";
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import ShowLargeImageModal from "./ShowLargeImageModal";
import BlueprintImageTableRaw from "./BlueprintImageTableRow";
import BlueprintImageAccordionContent from "./BlueprintImageAccordionContent";
import BlueprintImageAccordionTitle from "./BlueprintImageAccordionTitle";
import SuccessFlashMessage from "./SuccessFlashMessage";
import ErrorModal from "./ErrorModal";

const WishlistPage = ({
  wishlist,
  games,
  categories,
  eras,
  expansions,
  languages,
  versions,
  rarities,
  sorting_options,
  sorting_directions
}) => {

  const originalWishList = JSON.parse(wishlist);
  const [ allWishlistitemsIds, setAllWishlistitemsIds ] = useState([])
  const [ allBlueprintImagesIds, setAllBlueprintImagesIds ] = useState([])
  const [ initCompleted, setInitCompleted ] = useState(false)
  const [ wishlistItems, setWishlistItems ] = useState([]);
  const initialFilters = {
    name: null, game_id: null, category_id: null, era_id: null, expansion_id: null, language_filter: null, version: null, rarity: null,
    sort_by: 'id', sorting_direction: 'asc'
  }
  const [ filters, setFilters ] = useState(initialFilters)
  const [ erasForFilter, setErasForFilter ] = useState(eras)
  const [ expansionsForFilter, setExpansionsForFilter ] = useState(expansions)
  const [ page, setPage ] = useState(1);
  const [ hasLoadedAllWishlistItems, setHasLoadedAllWishlistItems ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ filterPannelIsOpen, setFilterPannelIsOpen ] = useState(false);
  const [ actionsPannelIsOpen, setActionsPannelIsOpen ] = useState(false);
  const [ showDeleteCardsPopup, setShowDeleteCardsPopup ] = useState(false)
  const [ showDeleteSingleCardPopup, setShowDeleteSingleCardPopup ] = useState(false)
  const [ showZoomImg, setShowZoomImg ] = useState(false)
  const [ blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage ] = useState(null)
  const [ idCardToDelete, setIdCardToDelete ] = useState(null)
  const [ showErrorModal, setShowErrorModal ] = useState(false)
  const [ showSuccessFlashMessage, setShowSuccessFlashMessage ] = useState(false)


  // console.log("all_wishlist_items_ids: ", allWishlistitemsIds);
  // console.log("all_blueprint_images_ids: ", allBlueprintImagesIds);

  useEffect(() => {
    if (initCompleted && wishlistItems.length === 0) {
      getWishlistItems()
    }
  }, [wishlistItems]);


  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)
      setAllWishlistitemsIds(originalWishList.wishlist_items_ids)
      setAllBlueprintImagesIds(originalWishList.blueprint_images_ids)
      appendWishlistItems(originalWishList.wishlist_items)

      enterDownHandler(setFilterPannelIsOpen)
    }
  }, []);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateFilterName();
      return debouncedUpdateFilterName.cancel;
    }
  }, [filters.name, debouncedUpdateFilterName]);


  useEffect(() => {
    if (filters.expansion_id)
      setTimeout(() => { $("span.select2-selection.select2-selection--single").addClass("border-aiG-blue-imp"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("border-aiG-blue-imp");
  }, [filters]);



  const handleChangeExpansionFilter = (e) => {
    getWishlistItemsByMatchingFilters('expansion_id', e.target.value)
  }



  useEffect(() => {
    buildEditableSelect(handleChangeExpansionFilter)
  }, [ filterPannelIsOpen, filters ]);



  // Funzione che permette di ottenere dal server nuove carte da renderizzare sull'interfaccia grafica
  const getWishlistItems = () => {
    if (!hasLoadedAllWishlistItems) {
      let url = `/wishlists/${originalWishList.id}/edit.json?page=${page}&per_page=${DEFAULT_PER_PAGE_PARAM}`
      Object.entries(filters).forEach(([fieldName, fieldValue]) => {
        if (fieldValue !== null)
          url += `&${fieldName}=${fieldValue}`
      })

      fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          setAllWishlistitemsIds(data.wishlist_items_ids)
          setAllBlueprintImagesIds(data.blueprint_images_ids)
          setLoading(false)
          appendWishlistItems(data.wishlist_items)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette di concatenare le nuove carte ottenute del server all'array che contiene tutte le
  // carte da mostrare sull'interfaccia grafica all'utente
  const appendWishlistItems = (newWishlistItems) => {
    setWishlistItems(wishlistItems.concat(newWishlistItems));
    setPage(page + 1)
    if (newWishlistItems.length < DEFAULT_PER_PAGE_PARAM)
      setHasLoadedAllWishlistItems(true)
  }


  // Funzione che permette di ottenere dal server le carte della my collection dell'utente che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getWishlistItemsByMatchingFilters = (filter, value) => {
    const newFilters = { ...filters }
    newFilters[filter] = value;
    if (['game_id', 'era_id'].includes(filter))
      newFilters['expansion_id'] = null;
    if (filter === 'game_id')
      newFilters['era_id'] = null;
    updateFilters(newFilters)
  }


  //Funzione che esegue l'update debouncato del filtro di ricerca delle carte per nome
  const debouncedUpdateFilterName = useCallback(
    debounce(() => updateFilters(filters), LOW_DEBOUNCE_TIME),
    [filters.name]
  );

  //Funzione che setta il nuovo filtro di ricerca delle carte per nome
  function onChangeFilterNameHandler(newFilterName) {
    const newFilters = { ...filters }
    newFilters['name'] = newFilterName;
    setFilters(newFilters)
  }


  // Funzione che aggiorna le opzioni dal filtro di ricerca degli wishlistItems per ere e espansioni quando l'utente
  // seleziona uno specifico game per filtrarle
  const filterErasAndExpansionsByGame = (game_id) => {
    const filteredEras = eras.filter(era => (era.game_id == game_id) || (!game_id || game_id === ""))
    const filteredExpansions = expansions.filter(expansion => (expansion.game_id == game_id) || (!game_id || game_id === ""))
    setErasForFilter(filteredEras)
    setExpansionsForFilter(filteredExpansions)
  }


  // Funzione che aggiorna le opzioni dal filtro di ricerca degli wishlistItems per espansioni quando l'utente
  // seleziona una specifica era per filtrarle
  const filterExpansionsByEra = (era_id) => {
    const filteredExpansions = expansions.filter(expansion => (expansion.era_id == era_id) || (!era_id || era_id === ""))
    setExpansionsForFilter(filteredExpansions)
  }


  // Funzione che aggiorna i filtri di ricerca delle carte specificate dall'utente sull'interfaccia grafica e rilancia
  // la ricerca sulla carte della my collection che matchano con i nuovi filtri specificati
  const updateFilters = (newFilters) => {
    setFilters(newFilters)
    setLoading(true)
    setPage(1)
    setHasLoadedAllWishlistItems(false)
    setWishlistItems([]);
  }


  // Funzione che si occupa di resettare tutti i filtri di ricerca specificati dall'utente sull'interfaccia grafica
  const handleResetFilters = () => {
    $('.select2-custom').val('').trigger('change.select2');
    updateFilters(initialFilters);
    setErasForFilter(eras)
    setExpansionsForFilter(expansions)
    if (window.innerWidth <= IPAD_WIDTH)
      setFilterPannelIsOpen(false)
  }


  //Funzione che elimina una carta specifica carta dalla wishlist
  function onDeleteHandler(wishlistItemId) {
    const url = `/wishlist_items/${wishlistItemId}`;

    fetch(url, {
      method: "DELETE",
    })
      .then((response) => {
        console.log("response: ", response);
      })
      .then((data) => {
        let newWishlistItems = []
        let newWishlistItemsIds = []
        let newBlueprintImagesIds = []

        for (const wishlistItem of wishlistItems) {
          if (wishlistItem.id !== wishlistItemId) {
            newWishlistItems.push(wishlistItem)
            newWishlistItemsIds.push(wishlistItem.id)
            newBlueprintImagesIds.push(wishlistItem.blueprint_image.id)
          }
        }

        setWishlistItems(newWishlistItems);
        setAllWishlistitemsIds(newWishlistItemsIds)
        setAllBlueprintImagesIds(newBlueprintImagesIds)
        setShowSuccessFlashMessage(true)
      })
      .catch((error) => {
        console.error("ERROR:", error);
        setShowErrorModal(true);
      });
  }

  //Funzione che elimina TUTTE le carte presenti all'interno della wishlist e che matchano coi filtri di ricerca specificati dall'utente
  function onDeleteAllHandler() {
    const url = `/wishlists/delete_all_items/${originalWishList.id}`;

    fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({wishlist_items_ids: allWishlistitemsIds}),
    })
      .then((response) => {
        console.log("response: ", response);
      })
      .then((data) => {
        setAllWishlistitemsIds([])
        setAllBlueprintImagesIds([])
        setWishlistItems([]);
        setShowSuccessFlashMessage(true)
      })
      .catch((error) => {
        console.error("ERROR:", error);
        setShowErrorModal(true);
      });
  }

  //Funzione che gestisce l'apertura della modale per l'eliminazione della carta
  const showPopupToDeleteACard = (cardToDelete) => {
    setIdCardToDelete(cardToDelete)
    setShowDeleteSingleCardPopup(true)
  }


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita di una carta
  const handleShowLargeImage = (e, blueprintImage) => {
    e.stopPropagation();
    if (blueprintImage && blueprintImage.xx_large_image_url) {
      setBlueprintImage2ShowLargeImage(blueprintImage)
      setShowZoomImg(true)
    }
  }

  
  return (
    <React.Fragment>
      <div className="w-90 m-auto mt-10px">

        <div
          className={`${filterPannelIsOpen ? 'mt-my-wishlist-with-open-filter-menu' : actionsPannelIsOpen ? 'mt-my-wishlist-with-open-action-menu' : 'mt-2'}  title-core-pages`}>
          <h2>{I18n.t('js.myWishlistEditPage.title')}</h2>
        </div>

        {
          !loading && allWishlistitemsIds.length > 0 &&
          <div className="row mt-3">
            <div className="col-12 col-md-6">
              <p>
                {allWishlistitemsIds.length}&nbsp;
                {pluralize(allWishlistitemsIds.length, 'editSubmissionListPage.product')}
              </p>
            </div>
          </div>
        }

        {/*filtri*/}

        <div>
          {
            !filterPannelIsOpen && !actionsPannelIsOpen ?

              <React.Fragment>
                <div className="button-show-all-sub-expansion show-on-desktop-d-block minH-47px rounded-right">
                  <button type="button" className="btn pr-5px" id="open_actions_panel"
                          onClick={() => setActionsPannelIsOpen(true)}>
                    <i className="fas fa-pencil-alt icon-in-btn-size ml-8px text--size-27px-imp"/>
                  </button>
                </div>

                <div
                  className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) && 'icon--bg-active'} rounded-right show-on-desktop expansion__filter--mobile-position top-170px`}>
                  <button type="button" className="btn p-7px" id="open_filter_panel"
                          onClick={(e) => setFilterPannelIsOpen(true)}>
                    <i
                      className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`}/>
                  </button>
                </div>


                {/*mobile button*/}
                <div
                  className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) && 'icon--bg-active'} rounded-right show-on-mobile expansion__filter--mobile-position`}>
                  <button type="button" className="btn p-7px"
                          onClick={(e) => setFilterPannelIsOpen(true)}>
                    <i
                      className={`${JSON.stringify(filters) !== JSON.stringify(initialFilters) ? 'icon--color-active' : 'icon-color-standard'} fas fa-filter enable-filters-expansions-icon`}/>
                  </button>
                </div>

                <div className="button-show-all-sub-expansion-on-mobile show-on-mobile-d-block ">
                  <button type="button" className="btn"
                          onClick={() => setActionsPannelIsOpen(true)}>
                    <i className="fas fa-pencil-alt icon-in-btn-size ml-8px text--size-27px-imp"/>
                  </button>
                </div>

              </React.Fragment>
              :
              <React.Fragment>
                {
                  filterPannelIsOpen &&
                  <div className="pl-4 pr-4 pb-4 filters-top-bar bg-light overflow-auto expansion--mobile--bt shadow"
                       id="filters">

                    <div className="row">
                      <div className="col-12 text-right p-lg-0">
                        <button type="button" className="btn p-0 mt-8px mr-4px" id="close_filter_panel"
                                onClick={(e) => setFilterPannelIsOpen(false)}>
                          <i className="fas fa-times show-on-mobile"/>
                          <i className="fas fa-times show-on-desktop-imp"/>
                        </button>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-12">
                        <h4 className="mt-0">{I18n.t('js.filters.by')}</h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.cardName')}</p>
                        <input
                          type="text"
                          value={filters.name ? filters.name : ""}
                          className={`form-control ${filters.name ? 'border-aiG-blue-imp' : ''}`}
                          placeholder={I18n.t('js.filters.placeholder.cardName')}
                          onChange={(e) => onChangeFilterNameHandler(e.target.value)}
                          name="card_name_filter"
                          id="card_name_filter"
                        />
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.cardInfoPage.game')}</p>
                        <select
                          className={`form-control ${filters.game_id ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.game_id ? filters.game_id : ""}
                          name="game_filter"
                          id="game_filter"
                          onChange={(e) => {
                            filterErasAndExpansionsByGame(e.target.value);
                            getWishlistItemsByMatchingFilters('game_id', e.target.value)
                          }}
                        >
                          <option value={""}>{I18n.t('js.filters.game')}</option>
                          {games.map((game) => (
                            <option value={game.id} key={game.id}>
                              {game.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.category')}</p>
                        <select
                          className={`form-control ${filters.category_id ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.category_id ? filters.category_id : ""}
                          name="category_filter"
                          id="category_filter"
                          onChange={(e) => getWishlistItemsByMatchingFilters('category_id', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCategory')}</option>
                          {categories.map((category) => (
                            <option value={category.id} key={category.id}>
                              { parseCategoryName(category.name) }
                            </option>
                          ))}
                        </select>
                      </div>

                      {
                        erasForFilter && erasForFilter.length > 0 &&
                          <div className="col-lg-2 col-md-3 col-6 mb-2">
                          <p className="mb-0">{I18n.t('js.filters.sort.era')}</p>
                          <select
                            className={`form-control ${filters.era_id ? 'border-aiG-blue-imp' : ''} p-0`}
                            value={filters.era_id ? filters.era_id : ""}
                            name="era_filter"
                            id="era_filter"
                            onChange={(e) => {
                              filterExpansionsByEra(e.target.value);
                              getWishlistItemsByMatchingFilters('era_id', e.target.value)
                            }}
                          >
                            <option value={""}>{I18n.t('js.filters.defaultEra')}</option>
                            {erasForFilter.map((era) => (
                              <option value={era.id} key={era.id}>
                                {era.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      }

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.expansion')}</p>
                        <select
                          className="form-control select2-custom p-0"
                          value={filters.expansion_id ? filters.expansion_id : ""}
                          name="expansion_filter"
                          id="expansion_filter"
                          onChange={(e) => {}}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultExpansion')}</option>
                          {expansionsForFilter.map(expansion => {
                            return <option value={expansion.id} key={expansion.id} label={expansion.icon}>
                              {expansion.name}
                            </option>
                          })}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.cardLanguage')}</p>
                        <select
                          className={`form-control ${filters.language_filter ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.language_filter ? filters.language_filter : ""}
                          name="language_filter"
                          id="language_filter"
                          onChange={(e) => getWishlistItemsByMatchingFilters('language_filter', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCardLanguage')}</option>
                          {languages.map((language) => (
                            <option value={language.name} key={language.name}>
                              {parseLanguage(language.name)}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.rarity')}</p>
                        <select
                          className={`form-control ${filters.rarity ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.rarity ? filters.rarity : ""}
                          name="rarity_filter"
                          id="rarity_filter"
                          onChange={(e) => getWishlistItemsByMatchingFilters('rarity', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCardRarity')}</option>
                          {rarities.map((rarity) => (
                            <option value={rarity.name} key={rarity.name}>
                              {titleize(rarity.name)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2">
                        <p className="mb-0">{I18n.t('js.filters.sort.version')}</p>
                        <select
                          className={`form-control ${filters.version ? 'border-aiG-blue-imp' : ''} p-0`}
                          value={filters.version ? filters.version : ""}
                          name="version_filter"
                          id="version_filter"
                          onChange={(e) => getWishlistItemsByMatchingFilters('version', e.target.value)}
                        >
                          <option value={""}>{I18n.t('js.filters.defaultCardVersion')}</option>
                          {versions.map((version) => (
                            <option value={version.name} key={version.name}>
                              {titleize(version.name)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2 mt-17px">
                        <button
                          className="btn-standard-outline br-20px mt-1 pt-1 pb-1 btn-standard-outline-resized w-100"
                          onClick={handleResetFilters}>
                          {I18n.t('js.filters.resetFilter')}
                        </button>
                      </div>

                      <div className="col-lg-2 col-md-3 col-6 mb-2 mt-17px show-on-mobile">
                        <button
                          className="btn-standard bg-aig-gradient text-light br-20px mt-1 pt-1 pb-1 btn-standard-outline-resized w-100"
                          onClick={(e) => setFilterPannelIsOpen(false)}>
                          {I18n.t('js.advancedSearch.filterComponent.search')}
                        </button>
                      </div>
                    </div>


                    <div className="row mb-2 mt-3">
                      <div className="col-12">
                        <h4 className="mt-0">{I18n.t('js.indexOrdersPage.sortBy')}</h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className=" col-xs-12 col-lg-4 d-flex justify-content-start align-items-center">
                        <select
                          className={`form-control ${filters.sort_by ? 'border-aiG-blue-imp' : ''} mr-1 p-0`}
                          name="sort_by" id="sort_by" value={filters.sort_by}
                          style={{minWidth: "60%"}}
                          onChange={(e) => getWishlistItemsByMatchingFilters('sort_by', e.target.value)}>
                          {sorting_options.map(option => {
                            return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                          })}
                        </select>
                        <span>
                        <b>:</b>
                        </span>
                        <select
                          className={`form-control ${filters.sorting_direction ? 'border-aiG-blue-imp' : ''} ml-1 p-0`}
                          name="sorting_direction" id="sorting_direction"
                          value={filters.sorting_direction}
                          onChange={(e) => getWishlistItemsByMatchingFilters('sorting_direction', e.target.value)}>
                          {sorting_directions.map(direction => {
                            return <option value={direction.value}
                                           key={direction.value}>{I18n.t(direction.locale)}</option>
                          })}
                        </select>
                      </div>
                    </div>

                  </div>
                }

                {
                  actionsPannelIsOpen &&
                  <div className="pl-4 pr-4 pb-4 filters-top-bar bg-light overflow-auto expansion--mobile--bt shadow"
                       id="actions">

                    <div className="row">
                      <div className="col-12 text-right p-lg-0">
                        <button type="button" className="btn p-0 mt-8px mr-4px"
                                onClick={(e) => setActionsPannelIsOpen(false)}>
                          <i className="fas fa-times show-on-mobile"/>
                          <i className="fas fa-times show-on-desktop-imp"/>
                        </button>
                      </div>
                    </div>

                    <div className="row mt-10px">
                      <div className="col-lg-3 col-md-6 col-12 mb-2 text-center mb-20px-imp">
                        <button
                          type="button"
                          className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized w-100 h-100"
                          onClick={() => window.location.href = `/products?blueprint_images_ids=${allBlueprintImagesIds}`}
                          // href={`/products?blueprint_images_ids=${allBlueprintImagesIds}`}
                        >
                          {I18n.t('js.myWishlistEditPage.actionsButtonViewOffers')}
                        </button>
                      </div>

                      <div className="col-lg-3 col-md-6 col-12 mb-2 text-center mb-20px-imp">
                        <button
                          type="button"
                          className="btn-standard-outline pr-2 pl-2 btn-standard-outline-resized h-100 pt-10px-imp w-100"
                          onClick={() =>
                            setShowDeleteCardsPopup(true)
                          }
                        >
                          {I18n.t('js.myWishlistEditPage.actionsButtonDeleteAllCard')}
                        </button>
                      </div>
                    </div>

                    <div className="col-12 mb-0 text-right">
                      <IconTooltip
                        tooltipPosition={'bottom'}
                        tooltipIcon={'fas fa-question-circle'}
                        tooltipTitle={I18n.t('js.myCollectionEditPage.infoTooltipMenuActionsTitle')}
                        tooltipContent={I18n.t('js.myCollectionEditPage.infoTooltipMenuActionsContent')}
                        iconColor={'#4d4e5b'} //blu scuro usato per il bottone standard
                      />
                    </div>

                  </div>
                }
              </React.Fragment>

          }
        </div>


          {
            loading ?
              <div className="d-flex justify-content-center mt-5">
                <div className="d-flex align-items-center text-muted">
                  <div className="spinner-border" role="status" />
                  <b className="ml-2">{I18n.t('js.myCollectionEditPage.loading')}</b>
                </div>
              </div>
              :
              wishlistItems.length > 0 ?
                <BottomScrollListener onBottom={getWishlistItems}>
                  <div className="d-none d-lg-block table-responsive">
                    <table id="wishlist-edit" className="table table-hover mt-30px bg-white">
                      <thead className="thead-dark">
                      <tr>
                        <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderImage')}</th>
                        <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderProperty')}</th>
                        <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderName')}</th>
                        <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderGame')}</th>
                        <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderCategory')}</th>
                        {
                          eras && eras.length > 0 &&
                            <th scope="col"
                                className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderEra')}</th>
                        }
                        <th scope="col"
                            className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderExpansion')}</th>
                        <th className="text-center" />
                        <th className="text-center" />
                      </tr>
                      </thead>
                      <tbody>
                      {wishlistItems.map((item, i) => {
                        return (<tr key={item.id} id={item.id} className="mt-10px mb-10px">
                          <BlueprintImageTableRaw
                            blueprintImage={item.blueprint_image}
                            handleShowLargeImage={handleShowLargeImage}
                            id={item.id}
                            displayEra={erasForFilter && erasForFilter.length > 0}
                          />

                          <td className="text-center">
                            {
                              item.has_offers &&
                              <button
                                id={`view-offers-wishlist-btn-${item.blueprint_image.id}`}
                                type="button"
                                className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto btn-inside-table text--white-space-no-wrap"
                                onClick={(e) => window.location.href = `/products/${item.blueprint_image.id}`}
                              >
                                {I18n.t("js.myWishlistEditPage.viewOffers")}
                              </button>
                            }
                          </td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn m-2"
                              onClick={() =>
                                showPopupToDeleteACard(item.id)
                              }
                            >
                              <i className="fas fa-fw fa-trash fa-lg" />
                            </button>
                          </td>
                        </tr>)
                      })}
                      </tbody>
                    </table>
                  </div>

                  <div className="show-on-mobile-d-block">
                    {wishlistItems.map((item, i) => {
                      return (<Accordion defaultActiveKey={wishlistItems[0].id} className="w-100 mb-3 border-aiG-black-imp br-8px" key={item.id}>
                        <Card className="bg-white border-none border-round-standard">
                          <Accordion.Toggle as={Card.Header} eventKey={item.id}>
                            <div className="row">
                              <BlueprintImageAccordionTitle
                                blueprintImage={item.blueprint_image}
                                handleShowLargeImage={handleShowLargeImage}
                              />
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={item.id}>
                            <div className="row mt-10px pb-3">
                              <div className="col-12">
                                <BlueprintImageAccordionContent
                                  blueprintImage={item.blueprint_image}
                                />
                              </div>
                            </div>
                          </Accordion.Collapse>
                        </Card>
                      </Accordion>)
                    })}

                  </div>

                  {
                    !hasLoadedAllWishlistItems && wishlistItems.length > 0 ?
                      <div className="d-flex justify-content-center mt-5">
                        <div className="d-flex align-items-center text-muted">
                          <div className="spinner-border" role="status" />
                          <b className="ml-2">{I18n.t('js.common.loading')}</b>
                        </div>
                      </div>
                      :
                      <div/>
                  }

                </BottomScrollListener>
                :
                <div className="d-flex justify-content-center mt-2 pt-3">
                  <div className="d-flex align-items-center text-muted">
                    <p
                      className="text-space text-black-50 text--size-normal text-center text-bold">{I18n.t('js.filters.noResultsFound')}</p>
                  </div>
                </div>
          }



        {/*Alert for delete all cards*/}
        <AlertPopup
          showAlertPopup={showDeleteCardsPopup}
          onSuccess={onDeleteAllHandler}
          onDiscard={setShowDeleteCardsPopup}
          popupTitle={`${I18n.t('js.myCollectionEditPage.userPopupDeleteCardsTitle')}`}
          popupContent={`${I18n.t('js.myWishlistEditPage.userPopupDeleteCardsContent')}`}
          cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
          confirmButtonText={`${I18n.t('js.common.button.delete').toUpperCase()}`}
        />

        {/*Alert for delete all cards*/}
        <AlertPopup
          showAlertPopup={showDeleteSingleCardPopup}
          onSuccess={()=>onDeleteHandler(idCardToDelete)}
          onDiscard={setShowDeleteSingleCardPopup}
          popupTitle={`${I18n.t('js.myCollectionEditPage.userPopupDeleteCardsTitle')}`}
          popupContent={`${I18n.t('js.myWishlistEditPage.modalDeleteCard')}`}
          cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
          confirmButtonText={`${I18n.t('js.common.button.delete').toUpperCase()}`}
        />

        <ShowLargeImageModal
          blueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
          showZoomImg={showZoomImg}
          setShowZoomImg={setShowZoomImg}
        />

        <SuccessFlashMessage
          showSuccessFlashMessage={showSuccessFlashMessage}
          setShowSuccessFlashMessage={setShowSuccessFlashMessage}
        />

        <ErrorModal
          showErrorModal={showErrorModal}
          setShowErrorModal={setShowErrorModal}
        />
      </div>
  </React.Fragment>
  );
};

export default WishlistPage;